<template>
  <div class="page-bg relative min-h-screen max-w-full text-cream">

    <header class="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#160b24]/90 backdrop-blur-md">
      <div class="mx-auto flex h-14 max-w-6xl items-center justify-between gap-3 px-4">
        <a href="#top" class="shrink-0 font-display text-lg font-extrabold tracking-tight sm:text-xl">Raybae</a>
        <nav class="hidden items-center gap-6 text-sm font-medium text-cream/80 sm:flex">
          <a href="#links" class="hover:text-blush">Links</a>
          <a href="#work" class="hover:text-blush">Work</a>
          <a href="#contact" class="hover:text-blush">Contact</a>
        </nav>
        <a
          href="mailto:notRaybae@gmail.com"
          class="shrink-0 rounded-full bg-gradient-to-r from-grape to-blush px-3 py-2 text-xs font-semibold text-white shadow-pink sm:px-4 sm:text-sm"
        >
          Book a collab
        </a>
      </div>
      <nav class="flex items-center justify-center gap-5 border-t border-white/10 py-2 text-xs font-medium text-cream/80 sm:hidden">
        <a href="#links" class="hover:text-blush">Links</a>
        <a href="#work" class="hover:text-blush">Work</a>
        <a href="#contact" class="hover:text-blush">Contact</a>
      </nav>
    </header>
    <div class="header-spacer" aria-hidden="true"></div>

    <main id="top" class="relative z-10 min-w-0">
      <section class="hero-panel mx-auto grid w-full min-w-0 max-w-6xl items-center gap-8 overflow-x-clip px-4 py-8 md:grid-cols-[1.1fr_.9fr] lg:gap-10 lg:py-6">
        <div class="min-w-0">
          <div class="mb-4 flex flex-wrap gap-2 text-[10px] font-semibold uppercase tracking-[0.16em] text-blush sm:text-xs sm:tracking-[0.18em]">
            <span class="rounded-full border border-blush/30 bg-blush/10 px-3 py-1">Riot Games Partner</span>
            <span class="rounded-full border border-grape/30 bg-grape/10 px-3 py-1">Lebanon</span>
          </div>
          <h1 class="font-display text-[clamp(2.15rem,10vw,4.5rem)] font-extrabold leading-[0.95] break-words">
            Streamer and <span class="bg-gradient-to-r from-blush to-grape bg-clip-text text-transparent">content creator.</span>
          </h1>
          <p class="mt-4 max-w-xl text-base leading-relaxed text-cream/75 sm:mt-5 sm:text-lg lg:text-base xl:text-lg">
            I’m Raybae — a Lebanese VALORANT streamer and Riot Games Partner.
            I also do collab ads and UGC on Instagram and TikTok, and I run Rayven custom keyboards.
          </p>
          <div class="mt-6 flex flex-wrap gap-3 sm:mt-8 lg:mt-6">
            <a href="#links" class="rounded-full bg-cream px-5 py-3 text-sm font-semibold text-ink hover:bg-white lg:hidden">See links</a>
            <a href="https://www.twitch.tv/notraybae" target="_blank" rel="noopener" class="rounded-full border border-white/20 px-5 py-3 text-sm font-semibold hover:border-blush">Watch live</a>
          </div>
          <div class="mt-8 grid max-w-md grid-cols-3 gap-2 sm:mt-10 sm:gap-4 lg:mt-6">
            <div v-for="stat in stats" :key="stat.label" class="min-w-0 rounded-2xl border border-white/10 bg-white/5 px-2 py-3 sm:p-4">
              <p class="font-display text-xl font-extrabold sm:text-2xl">{{ stat.value }}</p>
              <p class="text-[10px] uppercase tracking-wide text-cream/50 sm:text-xs sm:tracking-wider">{{ stat.label }}</p>
            </div>
          </div>
        </div>

        <div class="relative mx-auto w-full min-w-0 max-w-sm lg:max-h-[min(28rem,52svh)]">
          <img
            :src="baseUrl + 'img/profile-hero.jpg'"
            alt="Raybae"
            class="w-full rounded-[2rem] border-4 border-white/10 lg:max-h-[min(28rem,52svh)] lg:object-cover lg:object-top"
          />
          <div class="mt-3 flex flex-wrap gap-2 text-sm lg:mt-3">
            <span class="rounded-full border border-white/10 bg-ink/80 px-4 py-2">
              <font-awesome-icon :icon="['fab', 'twitch']" class="mr-2 text-[#A970F4]" />
              Twitch Affiliate
            </span>
            <span class="rounded-full border border-white/10 bg-ink/80 px-4 py-2">
              <font-awesome-icon :icon="['fas', 'keyboard']" class="mr-2 text-blush" />
              Owner of Rayven
            </span>
          </div>
        </div>
      </section>

      <div class="relative mb-16 w-full max-w-full overflow-hidden border-y border-white/10 bg-white/5 py-3">
        <div class="marquee-track flex w-max gap-10 text-sm font-semibold uppercase tracking-[0.25em] text-cream/60">
          <span v-for="n in 2" :key="n" class="flex gap-10 px-6">
            <span v-for="item in ticker" :key="item + n">{{ item }}</span>
          </span>
        </div>
      </div>

      <section id="links" class="mx-auto max-w-6xl px-4 pb-20">
        <p class="text-xs font-semibold uppercase tracking-[0.2em] text-blush">Everywhere</p>
        <h2 class="mt-2 font-display text-4xl font-extrabold">Links</h2>
        <div class="mt-8 grid gap-3 md:grid-cols-2">
          <article
            v-for="link in links"
            :key="link.name"
            class="flex items-center justify-between rounded-2xl border border-white/10 bg-white/5 p-4 transition hover:border-blush/50 hover:bg-white/10"
          >
            <a :href="link.url" target="_blank" rel="noopener" class="flex flex-1 items-center gap-4">
              <span class="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-grape to-blush text-xl">
                <font-awesome-icon :icon="[link.type, link.logo]" />
              </span>
              <span>
                <span class="block font-display text-lg font-bold">{{ link.name }}</span>
                <span class="text-sm text-cream/55">{{ link.hint }}</span>
              </span>
            </a>
            <button
              class="ml-3 rounded-full border border-white/15 px-3 py-2 text-xs hover:border-blush"
              :aria-label="'Copy ' + link.name + ' link'"
              @click="copyLink(link.url)"
            >
              <font-awesome-icon :icon="['fas', copied === link.url ? 'check' : 'copy']" />
            </button>
          </article>
        </div>
      </section>

      <section id="work" class="mx-auto max-w-6xl px-4 pb-20">
        <div class="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p class="text-xs font-semibold uppercase tracking-[0.2em] text-blush">Portfolio</p>
            <h2 class="mt-2 font-display text-4xl font-extrabold">Ads &amp; content</h2>
            <p class="mt-2 max-w-xl text-cream/65">
              Collab ads, UGC, and stream content from Instagram and TikTok.
            </p>
          </div>
          <div class="flex flex-wrap justify-start gap-2 sm:justify-end">
            <button
              v-for="filter in filters"
              :key="filter.id"
              class="rounded-full px-4 py-2 text-sm font-semibold transition"
              :class="activeFilter === filter.id ? 'bg-cream text-ink' : 'border border-white/15 text-cream/70 hover:border-blush'"
              @click="activeFilter = filter.id"
            >
              {{ filter.label }}
            </button>
          </div>
        </div>

        <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <a
            v-for="item in visibleWork"
            :key="item.title"
            :href="item.url"
            target="_blank"
            rel="noopener"
            class="group relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-white/5"
          >
            <img
              v-if="item.image"
              :src="baseUrl + item.image"
              :alt="item.title"
              class="h-80 w-full object-cover transition duration-500 group-hover:scale-105"
              :style="{ objectPosition: item.focal || 'center' }"
            />
            <div
              v-else
              class="flex h-80 items-center justify-center"
              :class="item.platform === 'TikTok' ? 'bg-[#111111]' : 'bg-gradient-to-br from-grape/50 to-blush/40'"
            >
              <font-awesome-icon :icon="item.icon" class="text-6xl text-white/90" />
            </div>
            <div class="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent"></div>
            <div class="absolute bottom-0 left-0 right-0 p-5">
              <p class="text-xs font-semibold uppercase tracking-widest text-blush">{{ item.tag }}</p>
              <h3 class="mt-1 font-display text-xl font-bold">{{ item.title }}</h3>
              <p class="mt-1 text-sm text-cream/70">{{ item.caption }}</p>
            </div>
            <span class="absolute right-4 top-4 rounded-full bg-ink/70 px-3 py-1 text-xs backdrop-blur">
              <font-awesome-icon :icon="['fas', 'play']" class="mr-1" />
              {{ item.platform }}
            </span>
          </a>
        </div>
      </section>

      <section id="contact" class="mx-auto max-w-6xl px-4 pb-24">
        <div class="overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-br from-grape/30 via-ink to-blush/20 p-8 md:p-12">
          <p class="text-xs font-semibold uppercase tracking-[0.2em] text-blush">For brands</p>
          <h2 class="mt-3 max-w-2xl font-display text-4xl font-extrabold md:text-5xl">
            Need an ad that doesn’t look like an ad?
          </h2>
          <p class="mt-4 max-w-xl text-cream/75">
            Collab ads, UGC, and stream integrations for gaming, tech, and lifestyle brands.
            Email me or DM — I actually reply.
          </p>
          <div class="mt-8 flex flex-wrap gap-3">
            <a
              href="mailto:notRaybae@gmail.com"
              class="inline-flex items-center gap-2 rounded-full bg-cream px-5 py-3 font-semibold text-ink"
            >
              <font-awesome-icon :icon="['fas', 'envelope']" />
              notRaybae@gmail.com
            </a>
            <a
              href="https://www.instagram.com/notraybaee"
              target="_blank"
              rel="noopener"
              class="inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-3 font-semibold"
            >
              DM on Instagram
              <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" />
            </a>
          </div>
        </div>
      </section>
    </main>

    <p
      v-if="toast"
      class="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 rounded-full bg-cream px-4 py-2 text-sm font-semibold text-ink shadow-pink"
    >
      {{ toast }}
    </p>

    <transition name="announce">
      <div
        v-if="announceOpen"
        class="fixed inset-0 z-[80] flex items-end justify-center p-4 sm:items-center"
      >
        <button
          class="absolute inset-0 bg-[#120818]/70 backdrop-blur-md"
          aria-label="Dismiss announcement"
          @click="closeAnnounce"
        ></button>
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="announce-title"
          class="announce-card relative w-full max-w-[26rem] overflow-hidden rounded-[1.75rem] border border-white/15 p-6 sm:p-8"
        >
          <button
            class="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-cream/70 hover:border-blush hover:text-cream"
            aria-label="Close"
            @click="closeAnnounce"
          >
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
          <p class="text-[11px] font-semibold uppercase tracking-[0.22em] text-blush">{{ announcement.tag }}</p>
          <div class="mt-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-grape to-blush text-xl">
            <font-awesome-icon :icon="['fas', announcement.icon]" />
          </div>
          <h2 id="announce-title" class="mt-4 font-display text-3xl font-extrabold leading-tight">
            {{ announcement.title }}
          </h2>
          <p class="mt-3 text-sm leading-relaxed text-cream/70 sm:text-base">
            {{ announcement.body }}
          </p>
          <div class="mt-6 flex flex-col gap-3 sm:flex-row">
            <a
              :href="announcement.url"
              target="_blank"
              rel="noopener"
              class="inline-flex flex-1 items-center justify-center rounded-full bg-cream px-5 py-3 text-sm font-semibold text-ink hover:bg-white"
              @click="closeAnnounce"
            >
              {{ announcement.cta }}
            </a>
            <button
              class="inline-flex flex-1 items-center justify-center rounded-full border border-white/20 px-5 py-3 text-sm font-semibold text-cream/80 hover:border-blush"
              @click="closeAnnounce"
            >
              {{ announcement.dismiss }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import announcement from "../announcement";

export default {
  data() {
    return {
      announcement,
      baseUrl: process.env.BASE_URL,
      activeFilter: "all",
      copied: "",
      toast: "",
      announceOpen: false,
      announceTimer: null,
      ticker: [
        "Collab ads",
        "UGC",
        "VALORANT",
        "Riot Partner",
        "TikTok",
        "Instagram",
        "Rayven keyboards",
        "Twitch",
        "Lebanon",
      ],
      stats: [
        { value: "7.3K", label: "TikTok" },
        { value: "6.6K", label: "Instagram" },
        { value: "4.1K", label: "Twitch" },
      ],
      filters: [
        { id: "all", label: "All" },
        { id: "collabs", label: "Collabs" },
        { id: "instagram", label: "Instagram" },
        { id: "tiktok", label: "TikTok" },
        { id: "stream", label: "Streaming" },
      ],
      work: [
        {
          title: "TECNO Pova 8",
          caption: "Brand collab on Instagram — product in frame, talking to camera.",
          tag: "Collab ad",
          platform: "Instagram",
          category: ["collabs", "instagram", "tiktok"],
          image: "img/work-7.jpg",
          focal: "center 28%",
          url: "https://www.instagram.com/notraybaee/reel/DcjAtmAtqI-/",
        },
        {
          title: "Jag Gaming Lounge",
          caption: "Collab with Jag Gaming — I toured and filmed their lounge.",
          tag: "Collab",
          platform: "Instagram",
          category: ["collabs", "instagram", "tiktok"],
          image: "img/work-lounge.jpg",
          url: "https://www.instagram.com/reel/DaQLnyuR-wM/",
        },
        {
          title: "Story time",
          caption: "How I started gaming — a story time about me.",
          tag: "TikTok",
          platform: "TikTok",
          category: ["tiktok", "stream"],
          image: "img/tt-story.jpg",
          focal: "center 38%",
          url: "https://www.tiktok.com/@notraybaee/video/7659796952372104455",
        },
        {
          title: "Two seconds to trash talk",
          caption: "Pinned TikTok — 118K views.",
          tag: "TikTok",
          platform: "TikTok",
          category: ["tiktok", "stream"],
          image: "img/tt-trashtalk.jpg",
          url: "https://www.tiktok.com/@notraybaee/video/7459433102415285511",
        },
        {
          title: "VALORANT Partner POV",
          caption: "Partner-coded stream content that still feels like a meme.",
          tag: "Riot Partner",
          platform: "Instagram",
          category: ["stream", "instagram"],
          image: "img/work-6.jpg",
          url: "https://www.instagram.com/notraybaee/reel/DcoOk-HNzd2/",
        },
        {
          title: "Boosted bot in chat",
          caption: "The chaotic facecam + gameplay format brands actually want.",
          tag: "Streaming",
          platform: "Instagram",
          category: ["stream", "instagram"],
          image: "img/work-2.jpg",
          url: "https://www.instagram.com/notraybaee/reel/DHeVifGsSBj/",
        },
        {
          title: "Riot VALORANT collab",
          caption: "Official collab with VALORANT Arabic — posted on @valorantar.",
          tag: "Riot collab",
          platform: "Instagram",
          category: ["collabs", "instagram"],
          image: "img/work-riot.jpg",
          url: "https://www.instagram.com/reel/DYU5_bqD4Or/",
        },
        {
          title: "Rating gaming lounges",
          caption: "Pinned TikTok — 54K views. Talking-to-camera lounge reviews.",
          tag: "Viral",
          platform: "TikTok",
          category: ["tiktok", "stream", "instagram"],
          image: "img/work-1.jpg",
          url: "https://www.instagram.com/notraybaee/reel/DKSV-u9MUK7/",
        },
        {
          title: "Rayven keyboards",
          caption: "My brand — custom builds, switches, keycaps, full kits.",
          tag: "Brand",
          platform: "Rayven",
          category: ["collabs", "instagram"],
          image: "",
          icon: ["fas", "keyboard"],
          url: "https://www.instagram.com/rayvenlb/",
        },
        {
          title: "5 stacking be like",
          caption: "Bilingual Arabic / English hook. That’s the audience.",
          tag: "Streaming",
          platform: "Instagram",
          category: ["stream", "instagram"],
          image: "img/work-8.jpg",
          url: "https://www.instagram.com/notraybaee/reel/Dcy1LKax_AZ/",
        },
      ],
      links: [
        { name: "ARC Registration Link", hint: "GBarena — register here", type: "fas", logo: "trophy", url: "https://links.gbarena.com/NotRaybae" },
        { name: "Twitch", hint: "notraybae — live VALORANT", type: "fab", logo: "twitch", url: "https://www.twitch.tv/notraybae" },
        { name: "Discord", hint: "Community", type: "fab", logo: "discord", url: "https://discord.gg/raybae" },
        { name: "Donations", hint: "Support the stream", type: "fas", logo: "circle-dollar-to-slot", url: "https://streamlabs.com/notraybae/tip" },
        { name: "Rayven", hint: "Custom keyboards", type: "fas", logo: "keyboard", url: "https://rayvenstore.com" },
        { name: "TikTok", hint: "Collab ads + clips @notraybaee", type: "fab", logo: "tiktok", url: "https://www.tiktok.com/@notraybaee" },
        { name: "Instagram", hint: "Reels, ads, DMs", type: "fab", logo: "instagram", url: "https://www.instagram.com/notraybaee" },
        { name: "Wish List", hint: "Throne", type: "fas", logo: "gift", url: "https://throne.com/notraybae" },
        { name: "YouTube", hint: "Longer chaos", type: "fab", logo: "youtube", url: "https://www.youtube.com/@notraybaee" },
        { name: "Kick", hint: "notraybae", type: "fab", logo: "kickstarter-k", url: "https://kick.com/notraybae" },
        { name: "X", hint: "@notraybaee", type: "fab", logo: "x-twitter", url: "https://x.com/notraybaee" },
      ],
    };
  },
  computed: {
    visibleWork() {
      if (this.activeFilter === "all") return this.work;
      return this.work.filter((item) => item.category.includes(this.activeFilter));
    },
  },
  methods: {
    showCopied(url) {
      this.copied = url;
      this.toast = "Link copied";
      setTimeout(() => {
        this.copied = "";
        this.toast = "";
      }, 1800);
    },
    fallbackCopy(url) {
      const input = document.createElement("textarea");
      input.value = url;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        this.showCopied(url);
      } catch (err) {
        this.toast = "Copy this: " + url;
        setTimeout(() => {
          this.toast = "";
        }, 2400);
      }
      document.body.removeChild(input);
    },
    copyLink(url) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(() => this.showCopied(url)).catch(() => this.fallbackCopy(url));
        return;
      }
      this.fallbackCopy(url);
    },
    announceStorageKey() {
      return "raybae-announce-" + this.announcement.id;
    },
    closeAnnounce() {
      this.announceOpen = false;
      document.body.style.overflow = "";
      try {
        sessionStorage.setItem(this.announceStorageKey(), "1");
      } catch (err) {
        /* ignore */
      }
    },
    onAnnounceKey(event) {
      if (event.key === "Escape" && this.announceOpen) this.closeAnnounce();
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onAnnounceKey);
    if (!this.announcement.enabled) return;
    try {
      if (sessionStorage.getItem(this.announceStorageKey()) === "1") return;
    } catch (err) {
      /* show anyway */
    }
    this.announceTimer = setTimeout(() => {
      this.announceOpen = true;
      document.body.style.overflow = "hidden";
    }, 650);
  },
  beforeDestroy() {
    clearTimeout(this.announceTimer);
    window.removeEventListener("keydown", this.onAnnounceKey);
    document.body.style.overflow = "";
  },
};
</script>
